import { MonomerTypes, PolymerTypes } from '../helm/consts';
// hwe exports the HELM type vocabulary as `as const` objects (value-only), not
// TS enums, so we re-create the value+type duality the old `import X = Enum`
// aliases provided — consumers use these both as a value (`.RNA`) and as a type.
const HELM_POLYMER_TYPE = PolymerTypes;
const HELM_MONOMER_TYPE = MonomerTypes;
export { HELM_POLYMER_TYPE, HELM_MONOMER_TYPE };
// core fields of HELM library object used in toAtomicLevel function
export const HELM_CORE_FIELDS = [
    "symbol" /* HELM_FIELDS.SYMBOL */,
    "molfile" /* HELM_FIELDS.MOLFILE */,
    "rgroups" /* HELM_FIELDS.RGROUPS */,
    "name" /* HELM_FIELDS.NAME */,
    // HELM_FIELDS.MONOMER_TYPE, // add if terminal monomers for PEPTIDEs to be
    // supported
];
export const SDF_MONOMER_NAME = 'MonomerName';
// todo: ideally, keys should be expressed via constants
export const jsonSdfMonomerLibDict = {
    'monomerType': null, // -> Backbone
    'smiles': null,
    'name': 'Name',
    'author': null,
    'molfile': 'molecule',
    'naturalAnalog': 'MonomerNaturalAnalogCode',
    'rgroups': 'MonomerCaps',
    'createDate': null,
    'id': null,
    'polymerType': 'MonomerType',
    'symbol': 'MonomerName'
};
export const DUMMY_MONOMER = {
    'monomerType': 'Backbone',
    'smiles': '',
    'name': '',
    'author': 'Datagrok',
    'molfile': '',
    'naturalAnalog': '',
    'rgroups': [],
    'createDate': null,
    'id': 0,
    'polymerType': 'PEPTIDE',
    'symbol': ''
};
// range of hex nubers used in PepSea library to endode monomers
export const MONOMER_ENCODE_MIN = 0x100;
export const MONOMER_ENCODE_MAX = 0x40A;
export const RIBOSE_SYMBOL = 'r';
export const DEOXYRIBOSE_SYMBOL = 'd';
export const PHOSPHATE_SYMBOL = 'p';
export const HELM_WRAPPERS_REGEXP = new RegExp(`[${RIBOSE_SYMBOL}${DEOXYRIBOSE_SYMBOL}]\\((\\w)\\)${PHOSPHATE_SYMBOL}?`, 'g');
//# sourceMappingURL=const.js.map